/* eslint-disable */
// GENERATED by scripts/build-marketing-images.mjs — do not edit by hand.
// Re-run `npm run gen:images` after changing anything in brand/photos/.
// inputs: 14ca4f5861fe

import closingWindowCoast_800_webp from './closing-window-coast-800.webp';
import closingWindowCoast_998_webp from './closing-window-coast-998.webp';
import closingWindowCoast_800_jpg from './closing-window-coast-800.jpg';
import closingWindowCoast_998_jpg from './closing-window-coast-998.jpg';
import heroAbout_800_webp from './hero-about-800.webp';
import heroAbout_1400_webp from './hero-about-1400.webp';
import heroAbout_1912_webp from './hero-about-1912.webp';
import heroAbout_800_jpg from './hero-about-800.jpg';
import heroAbout_1400_jpg from './hero-about-1400.jpg';
import heroAbout_1912_jpg from './hero-about-1912.jpg';
import heroAssessments_800_webp from './hero-assessments-800.webp';
import heroAssessments_1400_webp from './hero-assessments-1400.webp';
import heroAssessments_1567_webp from './hero-assessments-1567.webp';
import heroAssessments_800_jpg from './hero-assessments-800.jpg';
import heroAssessments_1400_jpg from './hero-assessments-1400.jpg';
import heroAssessments_1567_jpg from './hero-assessments-1567.jpg';
import heroFrostFields_800_webp from './hero-frost-fields-800.webp';
import heroFrostFields_1400_webp from './hero-frost-fields-1400.webp';
import heroFrostFields_2400_webp from './hero-frost-fields-2400.webp';
import heroFrostFields_800_jpg from './hero-frost-fields-800.jpg';
import heroFrostFields_1400_jpg from './hero-frost-fields-1400.jpg';
import heroFrostFields_2400_jpg from './hero-frost-fields-2400.jpg';
import heroLaptopSofa_800_webp from './hero-laptop-sofa-800.webp';
import heroLaptopSofa_1400_webp from './hero-laptop-sofa-1400.webp';
import heroLaptopSofa_2400_webp from './hero-laptop-sofa-2400.webp';
import heroLaptopSofa_800_jpg from './hero-laptop-sofa-800.jpg';
import heroLaptopSofa_1400_jpg from './hero-laptop-sofa-1400.jpg';
import heroLaptopSofa_2400_jpg from './hero-laptop-sofa-2400.jpg';
import heroPondDive_800_webp from './hero-pond-dive-800.webp';
import heroPondDive_1400_webp from './hero-pond-dive-1400.webp';
import heroPondDive_2384_webp from './hero-pond-dive-2384.webp';
import heroPondDive_800_jpg from './hero-pond-dive-800.jpg';
import heroPondDive_1400_jpg from './hero-pond-dive-1400.jpg';
import heroPondDive_2384_jpg from './hero-pond-dive-2384.jpg';
import pillarBloodworkB_600_webp from './pillar-bloodwork-b-600.webp';
import pillarBloodworkB_736_webp from './pillar-bloodwork-b-736.webp';
import pillarBloodworkB_600_jpg from './pillar-bloodwork-b-600.jpg';
import pillarBloodworkB_736_jpg from './pillar-bloodwork-b-736.jpg';
import pillarBloodwork_600_webp from './pillar-bloodwork-600.webp';
import pillarBloodwork_1000_webp from './pillar-bloodwork-1000.webp';
import pillarBloodwork_1200_webp from './pillar-bloodwork-1200.webp';
import pillarBloodwork_600_jpg from './pillar-bloodwork-600.jpg';
import pillarBloodwork_1000_jpg from './pillar-bloodwork-1000.jpg';
import pillarBloodwork_1200_jpg from './pillar-bloodwork-1200.jpg';
import pillarFamilyB_800_webp from './pillar-family-b-800.webp';
import pillarFamilyB_1200_webp from './pillar-family-b-1200.webp';
import pillarFamilyB_800_jpg from './pillar-family-b-800.jpg';
import pillarFamilyB_1200_jpg from './pillar-family-b-1200.jpg';
import pillarFamily_800_webp from './pillar-family-800.webp';
import pillarFamily_1400_webp from './pillar-family-1400.webp';
import pillarFamily_1852_webp from './pillar-family-1852.webp';
import pillarFamily_800_jpg from './pillar-family-800.jpg';
import pillarFamily_1400_jpg from './pillar-family-1400.jpg';
import pillarFamily_1852_jpg from './pillar-family-1852.jpg';
import pillarLifestyleB_800_webp from './pillar-lifestyle-b-800.webp';
import pillarLifestyleB_960_webp from './pillar-lifestyle-b-960.webp';
import pillarLifestyleB_800_jpg from './pillar-lifestyle-b-800.jpg';
import pillarLifestyleB_960_jpg from './pillar-lifestyle-b-960.jpg';
import pillarLifestyle_600_webp from './pillar-lifestyle-600.webp';
import pillarLifestyle_900_webp from './pillar-lifestyle-900.webp';
import pillarLifestyle_600_jpg from './pillar-lifestyle-600.jpg';
import pillarLifestyle_900_jpg from './pillar-lifestyle-900.jpg';
import pillarMovementB_600_webp from './pillar-movement-b-600.webp';
import pillarMovementB_816_webp from './pillar-movement-b-816.webp';
import pillarMovementB_600_jpg from './pillar-movement-b-600.jpg';
import pillarMovementB_816_jpg from './pillar-movement-b-816.jpg';
import pillarMovement_600_webp from './pillar-movement-600.webp';
import pillarMovement_817_webp from './pillar-movement-817.webp';
import pillarMovement_600_jpg from './pillar-movement-600.jpg';
import pillarMovement_817_jpg from './pillar-movement-817.jpg';
import pillarNutritionB_600_webp from './pillar-nutrition-b-600.webp';
import pillarNutritionB_1000_webp from './pillar-nutrition-b-1000.webp';
import pillarNutritionB_600_jpg from './pillar-nutrition-b-600.jpg';
import pillarNutritionB_1000_jpg from './pillar-nutrition-b-1000.jpg';
import pillarNutrition_600_webp from './pillar-nutrition-600.webp';
import pillarNutrition_1000_webp from './pillar-nutrition-1000.webp';
import pillarNutrition_1080_webp from './pillar-nutrition-1080.webp';
import pillarNutrition_600_jpg from './pillar-nutrition-600.jpg';
import pillarNutrition_1000_jpg from './pillar-nutrition-1000.jpg';
import pillarNutrition_1080_jpg from './pillar-nutrition-1080.jpg';
import pillarRecordsB_600_webp from './pillar-records-b-600.webp';
import pillarRecordsB_816_webp from './pillar-records-b-816.webp';
import pillarRecordsB_600_jpg from './pillar-records-b-600.jpg';
import pillarRecordsB_816_jpg from './pillar-records-b-816.jpg';
import pillarRecords_800_webp from './pillar-records-800.webp';
import pillarRecords_1195_webp from './pillar-records-1195.webp';
import pillarRecords_800_jpg from './pillar-records-800.jpg';
import pillarRecords_1195_jpg from './pillar-records-1195.jpg';
import pillarSleepB_600_webp from './pillar-sleep-b-600.webp';
import pillarSleepB_834_webp from './pillar-sleep-b-834.webp';
import pillarSleepB_600_jpg from './pillar-sleep-b-600.jpg';
import pillarSleepB_834_jpg from './pillar-sleep-b-834.jpg';
import pillarSleep_600_webp from './pillar-sleep-600.webp';
import pillarSleep_900_webp from './pillar-sleep-900.webp';
import pillarSleep_600_jpg from './pillar-sleep-600.jpg';
import pillarSleep_900_jpg from './pillar-sleep-900.jpg';
import pillarSpecialistsB_600_webp from './pillar-specialists-b-600.webp';
import pillarSpecialistsB_834_webp from './pillar-specialists-b-834.webp';
import pillarSpecialistsB_600_jpg from './pillar-specialists-b-600.jpg';
import pillarSpecialistsB_834_jpg from './pillar-specialists-b-834.jpg';
import pillarSpecialists_600_webp from './pillar-specialists-600.webp';
import pillarSpecialists_1000_webp from './pillar-specialists-1000.webp';
import pillarSpecialists_600_jpg from './pillar-specialists-600.jpg';
import pillarSpecialists_1000_jpg from './pillar-specialists-1000.jpg';
import portraitSwim_600_webp from './portrait-swim-600.webp';
import portraitSwim_916_webp from './portrait-swim-916.webp';
import portraitSwim_600_jpg from './portrait-swim-600.jpg';
import portraitSwim_916_jpg from './portrait-swim-916.jpg';
import strip01_600_webp from './strip-01-600.webp';
import strip01_900_webp from './strip-01-900.webp';
import strip01_600_jpg from './strip-01-600.jpg';
import strip01_900_jpg from './strip-01-900.jpg';
import strip02_800_webp from './strip-02-800.webp';
import strip02_1400_webp from './strip-02-1400.webp';
import strip02_1602_webp from './strip-02-1602.webp';
import strip02_800_jpg from './strip-02-800.jpg';
import strip02_1400_jpg from './strip-02-1400.jpg';
import strip02_1602_jpg from './strip-02-1602.jpg';
import strip03_800_webp from './strip-03-800.webp';
import strip03_1400_webp from './strip-03-1400.webp';
import strip03_1700_webp from './strip-03-1700.webp';
import strip03_800_jpg from './strip-03-800.jpg';
import strip03_1400_jpg from './strip-03-1400.jpg';
import strip03_1700_jpg from './strip-03-1700.jpg';
import strip04_800_webp from './strip-04-800.webp';
import strip04_1389_webp from './strip-04-1389.webp';
import strip04_800_jpg from './strip-04-800.jpg';
import strip04_1389_jpg from './strip-04-1389.jpg';

export interface ImageSource { w: number; src: string }
export interface MarketingImage {
  width: number;
  height: number;
  portrait: boolean;
  /** 16px WebP, base64 — painted behind the real image while it loads. */
  lqip: string;
  webp: ImageSource[];
  jpg: ImageSource[];
}

export const IMAGES = {
  'closing-window-coast': {
    width: 998, height: 792, portrait: false,
    lqip: 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAADQAQCdASoQAA0ABUB8JQBOgBsuIdwAAAD+cbRRL1El+y8dD4Ef2zOYeFoY4bGEPbBLIhwiKPVQGtuGC60nWTvr59d1QgAA',
    webp: [{ w: 800, src: closingWindowCoast_800_webp }, { w: 998, src: closingWindowCoast_998_webp }],
    jpg: [{ w: 800, src: closingWindowCoast_800_jpg }, { w: 998, src: closingWindowCoast_998_jpg }],
  },
  'hero-about': {
    width: 1912, height: 1432, portrait: false,
    lqip: 'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADwAQCdASoQAAwABUB8JQBOgB6JgCLqknAA+4gfrb4XTV2iQvaUzPdNdjXt3SuoLNOMg/RkWnZi5SBY8hXp/27o0AA=',
    webp: [{ w: 800, src: heroAbout_800_webp }, { w: 1400, src: heroAbout_1400_webp }, { w: 1912, src: heroAbout_1912_webp }],
    jpg: [{ w: 800, src: heroAbout_800_jpg }, { w: 1400, src: heroAbout_1400_jpg }, { w: 1912, src: heroAbout_1912_jpg }],
  },
  'hero-assessments': {
    width: 1567, height: 1175, portrait: false,
    lqip: 'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADwAQCdASoQAAwABUB8JbACdADDsU7aIAAA/tn4irrHBp2iih78V9b22ALDEeG1EJ+NOPMuFl7Una9y0V+rxujhgAA=',
    webp: [{ w: 800, src: heroAssessments_800_webp }, { w: 1400, src: heroAssessments_1400_webp }, { w: 1567, src: heroAssessments_1567_webp }],
    jpg: [{ w: 800, src: heroAssessments_800_jpg }, { w: 1400, src: heroAssessments_1400_jpg }, { w: 1567, src: heroAssessments_1567_jpg }],
  },
  'hero-frost-fields': {
    width: 2400, height: 1350, portrait: false,
    lqip: 'data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAACwAQCdASoQAAkABUB8JQBOgCHLwKwgAPyOjVh84FXdI4bnh+7XhAdZCKjExeCoUzUAAA==',
    webp: [{ w: 800, src: heroFrostFields_800_webp }, { w: 1400, src: heroFrostFields_1400_webp }, { w: 2400, src: heroFrostFields_2400_webp }],
    jpg: [{ w: 800, src: heroFrostFields_800_jpg }, { w: 1400, src: heroFrostFields_1400_jpg }, { w: 2400, src: heroFrostFields_2400_jpg }],
  },
  'hero-laptop-sofa': {
    width: 2400, height: 1350, portrait: false,
    lqip: 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADQAQCdASoQAAkABUB8JaACdADy/mWsAADLH1KuyoBnv8I5hj49CTrwGddWfCNK1mnpHs4zaENGPhjjf46wAA==',
    webp: [{ w: 800, src: heroLaptopSofa_800_webp }, { w: 1400, src: heroLaptopSofa_1400_webp }, { w: 2400, src: heroLaptopSofa_2400_webp }],
    jpg: [{ w: 800, src: heroLaptopSofa_800_jpg }, { w: 1400, src: heroLaptopSofa_1400_jpg }, { w: 2400, src: heroLaptopSofa_2400_jpg }],
  },
  'hero-pond-dive': {
    width: 2384, height: 1341, portrait: false,
    lqip: 'data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoQAAkABUB8JZACdADzmWAAAPyO3Vy3f3C8hNWt4zavSxGyFFhhEdOqAAA=',
    webp: [{ w: 800, src: heroPondDive_800_webp }, { w: 1400, src: heroPondDive_1400_webp }, { w: 2384, src: heroPondDive_2384_webp }],
    jpg: [{ w: 800, src: heroPondDive_800_jpg }, { w: 1400, src: heroPondDive_1400_jpg }, { w: 2384, src: heroPondDive_2384_jpg }],
  },
  'pillar-bloodwork-b': {
    width: 736, height: 1103, portrait: true,
    lqip: 'data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAADQAwCdASoQABgAPzmGvFQvKSYjMAgB4CcJQBdgBDv4QIl+ME9uVUAA/uLXxIF7wT08kojsb4hX4DdXS0BRogGCykZTj4ceDm5gAA==',
    webp: [{ w: 600, src: pillarBloodworkB_600_webp }, { w: 736, src: pillarBloodworkB_736_webp }],
    jpg: [{ w: 600, src: pillarBloodworkB_600_jpg }, { w: 736, src: pillarBloodworkB_736_jpg }],
  },
  'pillar-bloodwork': {
    width: 1200, height: 1800, portrait: true,
    lqip: 'data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAACwAwCdASoQABgAPzmGuVOvKSWisAgB4CcJQBOmUAArPr2eFizlgAD+r5sjLfnXsHxawiMtOFLnFKZca2O06RVmG04k4OjQi+W1MuPc4e9Ggm6NRALLh/9LwAA=',
    webp: [{ w: 600, src: pillarBloodwork_600_webp }, { w: 1000, src: pillarBloodwork_1000_webp }, { w: 1200, src: pillarBloodwork_1200_webp }],
    jpg: [{ w: 600, src: pillarBloodwork_600_jpg }, { w: 1000, src: pillarBloodwork_1000_jpg }, { w: 1200, src: pillarBloodwork_1200_jpg }],
  },
  'pillar-family-b': {
    width: 1200, height: 800, portrait: false,
    lqip: 'data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAAAQAgCdASoQAAsABUB8JQBOgCFKxAq38YGwAP7p/o2mPEsBgQzdKqYtZNmeMNe6mo3WYtCakhjKDMkTdSYGwMwhS08LyhG58PLleHHSXFvAAA==',
    webp: [{ w: 800, src: pillarFamilyB_800_webp }, { w: 1200, src: pillarFamilyB_1200_webp }],
    jpg: [{ w: 800, src: pillarFamilyB_800_jpg }, { w: 1200, src: pillarFamilyB_1200_jpg }],
  },
  'pillar-family': {
    width: 1852, height: 1288, portrait: false,
    lqip: 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAADwAQCdASoQAAsABUB8JQAJwADRyfvdISAAzj4tkWy/jqkEczL9OsatUuGe6OhwHHK/uvf4DMdTAck9w2r0i0FkaF/ci3AA',
    webp: [{ w: 800, src: pillarFamily_800_webp }, { w: 1400, src: pillarFamily_1400_webp }, { w: 1852, src: pillarFamily_1852_webp }],
    jpg: [{ w: 800, src: pillarFamily_800_jpg }, { w: 1400, src: pillarFamily_1400_jpg }, { w: 1852, src: pillarFamily_1852_jpg }],
  },
  'pillar-lifestyle-b': {
    width: 960, height: 640, portrait: false,
    lqip: 'data:image/webp;base64,UklGRl4AAABXRUJQVlA4IFIAAACwAQCdASoQAAsABUB8JYwAAp2OL92wAP7hcSe0tCu6aIhj0qEx1Fy3YoA0g1jWL8FpGYEOs4xc/YzdMLFQlgWGJcwGu17Q0zyawbug8Me8XAAA',
    webp: [{ w: 800, src: pillarLifestyleB_800_webp }, { w: 960, src: pillarLifestyleB_960_webp }],
    jpg: [{ w: 800, src: pillarLifestyleB_800_jpg }, { w: 960, src: pillarLifestyleB_960_jpg }],
  },
  'pillar-lifestyle': {
    width: 900, height: 1200, portrait: true,
    lqip: 'data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAACwAwCdASoQABUAPzmEuVOvKKWisAgB4CcJQBOgBDVsBo2EDXUEoAD+rqH9EVCDOtVsfWl7t6RNJQ8KVs6q5DSKabkzMTp8PuGkKyoVvqORHfZ88Ej+IpaHWYJPIjhx4qvxbFUy0KSggAAA',
    webp: [{ w: 600, src: pillarLifestyle_600_webp }, { w: 900, src: pillarLifestyle_900_webp }],
    jpg: [{ w: 600, src: pillarLifestyle_600_jpg }, { w: 900, src: pillarLifestyle_900_jpg }],
  },
  'pillar-movement-b': {
    width: 816, height: 1020, portrait: true,
    lqip: 'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAABQBACdASoQABQAPzmEuVOvKKWisAgB4CcJYwCdB2gAPtVCVdIeudqRoZbgAP3967CWoOQpiqSW6AJhf31x5Shn0uLlSTwjPY4qybATwwmxirWzb14xlI6k1gl8AAAA',
    webp: [{ w: 600, src: pillarMovementB_600_webp }, { w: 816, src: pillarMovementB_816_webp }],
    jpg: [{ w: 600, src: pillarMovementB_600_jpg }, { w: 816, src: pillarMovementB_816_jpg }],
  },
  'pillar-movement': {
    width: 817, height: 1225, portrait: true,
    lqip: 'data:image/webp;base64,UklGRpAAAABXRUJQVlA4IIQAAACQAwCdASoQABgAPzmEuVOvKKWisAgB4CcJZgCsAALq/IPHeoPAAP5xo0MmNJlMLb4A5qf6baaZ380/UErEPzF1IuK5eEFdCeOL30wQO8GO2WMixb9Amzx+eZL+bBtDRSgRmxMmzIXLEUnhLin+Y0qYduECsEckvuZykJiup9pWAoiRAAA=',
    webp: [{ w: 600, src: pillarMovement_600_webp }, { w: 817, src: pillarMovement_817_webp }],
    jpg: [{ w: 600, src: pillarMovement_600_jpg }, { w: 817, src: pillarMovement_817_jpg }],
  },
  'pillar-nutrition-b': {
    width: 1000, height: 1295, portrait: true,
    lqip: 'data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAADwAgCdASoQABUAPzmGuVOvKSWisAgB4CcJYwCdAC1yAAD+5w1I/AtR6EYaLV6WGL2AA5raIAA=',
    webp: [{ w: 600, src: pillarNutritionB_600_webp }, { w: 1000, src: pillarNutritionB_1000_webp }],
    jpg: [{ w: 600, src: pillarNutritionB_600_jpg }, { w: 1000, src: pillarNutritionB_1000_jpg }],
  },
  'pillar-nutrition': {
    width: 1080, height: 1348, portrait: true,
    lqip: 'data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAACwAwCdASoQABQAPzmEuVOvKKWisAgB4CcJQBOgAp2eWhybR0EMdAD+Lrs7UuWWeXisJgaXN+ulZbMRheOqb20hu61C92aAPObr2TAAAAA=',
    webp: [{ w: 600, src: pillarNutrition_600_webp }, { w: 1000, src: pillarNutrition_1000_webp }, { w: 1080, src: pillarNutrition_1080_webp }],
    jpg: [{ w: 600, src: pillarNutrition_600_jpg }, { w: 1000, src: pillarNutrition_1000_jpg }, { w: 1080, src: pillarNutrition_1080_jpg }],
  },
  'pillar-records-b': {
    width: 816, height: 1020, portrait: true,
    lqip: 'data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAAAQBACdASoQABQAPzmEuVOvKKWisAgB4CcJaACdMoADExvplyYKOqS0AAD1S0qtEEN6KB0/PvkxVvYAmaH/WKl4Uyr1sDGq737xlOYRIm9EEUenprh8tt1IAAA=',
    webp: [{ w: 600, src: pillarRecordsB_600_webp }, { w: 816, src: pillarRecordsB_816_webp }],
    jpg: [{ w: 600, src: pillarRecordsB_600_jpg }, { w: 816, src: pillarRecordsB_816_jpg }],
  },
  'pillar-records': {
    width: 1195, height: 896, portrait: false,
    lqip: 'data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAADQAQCdASoQAAwABUB8JQBOgCG8pF5JSAD+5NQhXtmRRB7+6tIEPxoq4G9N6YFo6a+4AAAA',
    webp: [{ w: 800, src: pillarRecords_800_webp }, { w: 1195, src: pillarRecords_1195_webp }],
    jpg: [{ w: 800, src: pillarRecords_800_jpg }, { w: 1195, src: pillarRecords_1195_jpg }],
  },
  'pillar-sleep-b': {
    width: 834, height: 1043, portrait: true,
    lqip: 'data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAADQAwCdASoQABQAPzmGulQvKSWjMAgB4CcJQBfnBDdZqkOaUdwdkGAA/ujMoybgDYHeOHfd0kzimvxRsNSRSpYBJBVjne7UgZTz+mrBC8GJxb6TIVXcAA==',
    webp: [{ w: 600, src: pillarSleepB_600_webp }, { w: 834, src: pillarSleepB_834_webp }],
    jpg: [{ w: 600, src: pillarSleepB_600_jpg }, { w: 834, src: pillarSleepB_834_jpg }],
  },
  'pillar-sleep': {
    width: 900, height: 1200, portrait: true,
    lqip: 'data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAwAwCdASoQABUAPzmGulQvKSWjMAgB4CcJQBYdg1rvkKeAAPcfDFSOYfy7HWegZcMKve5/oAjmkMcBFZAQU7ubKUln2boEAAA=',
    webp: [{ w: 600, src: pillarSleep_600_webp }, { w: 900, src: pillarSleep_900_webp }],
    jpg: [{ w: 600, src: pillarSleep_600_jpg }, { w: 900, src: pillarSleep_900_jpg }],
  },
  'pillar-specialists-b': {
    width: 834, height: 1043, portrait: true,
    lqip: 'data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAADwAwCdASoQABQAPzmGuVOvKSWisAgB4CcJYwC7ABufYmbajRKffr0AAP6s5rWmcr2q5Hmtjm2mNYXruhdVNvdzlDUCHfy8MRCxXvPVpuvL1GqEgvwAAA==',
    webp: [{ w: 600, src: pillarSpecialistsB_600_webp }, { w: 834, src: pillarSpecialistsB_834_webp }],
    jpg: [{ w: 600, src: pillarSpecialistsB_600_jpg }, { w: 834, src: pillarSpecialistsB_834_jpg }],
  },
  'pillar-specialists': {
    width: 1000, height: 1333, portrait: true,
    lqip: 'data:image/webp;base64,UklGRnAAAABXRUJQVlA4IGQAAACwAwCdASoQABUAPzmIulQvKSWjMAgB4CcJQBWAA9Hy0KtF3JjoGAD+ufwLaGqhUHybkjz1buHSfd9lqDv8mgWFpQgM2rGCWOaforXxqBy9716gLG6jnJmUF+2arjxMzB19+AAA',
    webp: [{ w: 600, src: pillarSpecialists_600_webp }, { w: 1000, src: pillarSpecialists_1000_webp }],
    jpg: [{ w: 600, src: pillarSpecialists_600_jpg }, { w: 1000, src: pillarSpecialists_1000_jpg }],
  },
  'portrait-swim': {
    width: 916, height: 1145, portrait: true,
    lqip: 'data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAAAQBACdASoQABQAPzmEuVOvKKWisAgB4CcJYwC/OCHgYi5WMZCc8or/gAD+qwGRCwMAb2A15NVHWb6ZWe8CVvm0jiBt6fFZ1G+tLc3GCmErYkRFKSaYArxf4W3GxwFAiX365JO0u4dBunFsJUR0RkAA',
    webp: [{ w: 600, src: portraitSwim_600_webp }, { w: 916, src: portraitSwim_916_webp }],
    jpg: [{ w: 600, src: portraitSwim_600_jpg }, { w: 916, src: portraitSwim_916_jpg }],
  },
  'strip-01': {
    width: 900, height: 1200, portrait: true,
    lqip: 'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAAAQBACdASoQABUAPzmGuVOvKSWisAgB4CcJbACdMoRwABeqB1KXu2ucAAD+ulE6HahGfb/cE2QSzEVpWAjMuoG3xX6ivsleOUYluAL0tyclD+WveoomquvYuAqGh3rT5K8AAA==',
    webp: [{ w: 600, src: strip01_600_webp }, { w: 900, src: strip01_900_webp }],
    jpg: [{ w: 600, src: strip01_600_jpg }, { w: 900, src: strip01_900_jpg }],
  },
  'strip-02': {
    width: 1602, height: 901, portrait: false,
    lqip: 'data:image/webp;base64,UklGRkQAAABXRUJQVlA4IDgAAADQAQCdASoQAAkABUB8JZQAAurVoClIAAD+zgIcQnVEFpwfMflKmV7OClxHgLd0i25qz99q2wAAAA==',
    webp: [{ w: 800, src: strip02_800_webp }, { w: 1400, src: strip02_1400_webp }, { w: 1602, src: strip02_1602_webp }],
    jpg: [{ w: 800, src: strip02_800_jpg }, { w: 1400, src: strip02_1400_jpg }, { w: 1602, src: strip02_1602_jpg }],
  },
  'strip-03': {
    width: 1700, height: 1366, portrait: false,
    lqip: 'data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAAAQAgCdASoQAA0ABUB8JZACdADp4ha3wTAAAP3GdIBsanE/mrhdk42idanx6LYn+8K7fCZic3gNnjZK21O2QOOwXE2c7VqEZAAAAA==',
    webp: [{ w: 800, src: strip03_800_webp }, { w: 1400, src: strip03_1400_webp }, { w: 1700, src: strip03_1700_webp }],
    jpg: [{ w: 800, src: strip03_800_jpg }, { w: 1400, src: strip03_1400_jpg }, { w: 1700, src: strip03_1700_jpg }],
  },
  'strip-04': {
    width: 1389, height: 696, portrait: false,
    lqip: 'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAABQAQCdASoQAAgABUB8JYwABDOAAP7sPR5bLaH7Q0uDr+12ndgAAA==',
    webp: [{ w: 800, src: strip04_800_webp }, { w: 1389, src: strip04_1389_webp }],
    jpg: [{ w: 800, src: strip04_800_jpg }, { w: 1389, src: strip04_1389_jpg }],
  },
} as const satisfies Record<string, MarketingImage>;

export type ImageId = keyof typeof IMAGES;
